
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { InferGetStaticPropsType } from "next";
import { getBaseStaticProps } from "@/utils/slug";
import SiteLayout from "@/components/layout/site";
import { PageType } from '@/utils/router';
import SearchResult from '@/components/fasce/SearchResult';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';

const SearchPage = ({ data }: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation('common');
  const seoTitle = t(`search-result-page-title`, {}, {default: 'Ricerca'}) + ' - ' + t(`page-title-base`, {}, {default: 'Disano - Fosnova'});
	return <SiteLayout pageType={PageType.SEARCH} data={data}>
    <NextSeo title={seoTitle} />
    <SearchResult />
  </SiteLayout>
};

export default SearchPage;

 const _getStaticProps = getBaseStaticProps;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/search',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  